import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'
import { PanesPad } from 'modules/core/components/PanesPad'
import Toggler from 'modules/core/components/Toggler'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import type { Automation } from 'modules/automations/store/models/Automation'

import * as styles from './index.vanilla.css'

interface Props {
  automation: Automation
  toggleEnabled: () => void
}

const EMPTY_TEXT = '-'

export const Title = observer(({ automation, toggleEnabled }: Props) => {
  const createdBy = () => {
    if (!!automation.attributes.slug) return 'Factorial' // eslint-disable-line no-extra-boolean-cast

    const user = users.get(automation.attributes.access_id)

    return user
      ? getFullDisplayName({
          firstName: user.attributes.first_name,
          lastName: user.attributes.last_name,
        })
      : EMPTY_TEXT
  }

  const createdByLabel = createdBy()

  return (
    <PanesPad>
      <PanesHeader title={i18n.t('automations.show.details.title')} separation />
      <div>
        <div className={styles.toggler}>
          <div className={styles.togglerContainer}>
            <Toggler
              disabled={false}
              active={automation.attributes.enabled}
              type="correct"
              onChange={toggleEnabled}
            />
          </div>
          <Text.Normal>
            {automation.attributes.enabled
              ? i18n.t('automations.show.details.enabled')
              : i18n.t('automations.show.details.disabled')}
          </Text.Normal>
        </div>
        <div className={styles.text}>
          <div>
            <Text.Normal weight="semibold" size="200">
              {i18n.t('automations.automation.created_by')}
            </Text.Normal>
          </div>
          <div>
            <Text.Normal color={createdByLabel === EMPTY_TEXT ? 'grey1000' : 'grey800'}>
              {createdByLabel}
            </Text.Normal>
          </div>
        </div>
      </div>
    </PanesPad>
  )
})
